export const ROUTES = {
  home: { path: "/", label: "Ordo Intelligence", area: "home" },
  ordo: { path: "/ordo", label: "General Ordo", area: "ordo", parent: "home" },
  infrastructure: { path: "/ordo/infrastructure", label: "General Ordo Infrastructure", area: "ordo", parent: "ordo" },
  engine: { path: "/ordo/engine", label: "Ordo Engine", area: "ordo", parent: "ordo" },
  stewardship: { path: "/ordo/stewardship", label: "Ordo Stewardship", area: "ordo", parent: "ordo" },
  enterprise: { path: "/enterprise", label: "Diagnostics & Software", area: "enterprise", parent: "home" },
  diagnostic: { path: "/enterprise/diagnostic", label: "Ordo Diagnostic", area: "enterprise", parent: "enterprise" },
  software: { path: "/enterprise/software", label: "Applied software", area: "enterprise", parent: "enterprise" },
  breakpoint: { path: "/enterprise/breakpoint", label: "Breakpoint", area: "enterprise", parent: "software" },
  mesh: { path: "/enterprise/mesh", label: "Mesh", area: "enterprise", parent: "software" },
  research: { path: "/research", label: "Research & Products", area: "research", parent: "home" },
  briefcase: { path: "/products/briefcase", label: "Briefcase", area: "briefcase", parent: "research" },
  forma: { path: "/products/forma", label: "Forma", area: "forma", parent: "research" },
  lumen: { path: "/products/lumen", label: "Lumen", area: "lumen", parent: "research" },
  engage: { path: "/engage", label: "Engage", area: "engage", parent: "home" },
};

export const AREA_THEME = {
  home: "t-ink",
  ordo: "t-ordo",
  enterprise: "t-paper",
  research: "t-stone",
  briefcase: "t-briefcase",
  forma: "t-forma",
  lumen: "t-lumen",
  engage: "t-paper",
};

export const AREA_GROUP = {
  ordo: "ordo",
  enterprise: "enterprise",
  research: "research",
  briefcase: "research",
  forma: "research",
  lumen: "research",
};

export const keyForPath = (pathname = "/") => {
  const clean = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return Object.keys(ROUTES).find((k) => ROUTES[k].path === clean);
};

export const trail = (key, via) => {
  const chain = [key];
  let next = via || ROUTES[key].parent;
  while (next) {
    chain.unshift(next);
    next = ROUTES[next].parent;
  }
  return chain;
};

export const NAV_GROUPS = [
  {
    key: "ordo",
    label: "General Ordo",
    note: "The governing architecture and its expressions",
    items: [
      { key: "ordo", label: "Overview & architecture explorer" },
      { key: "infrastructure", label: "Infrastructure", note: "Separate licensing route" },
      { key: "engine", label: "Ordo Engine", note: "Present judgment" },
      { key: "stewardship", label: "Ordo Stewardship", note: "Continuing standing" },
    ],
  },
  {
    key: "enterprise",
    label: "Diagnostics & Software",
    note: "Customer-originated work",
    items: [
      { key: "enterprise", label: "Overview" },
      { key: "diagnostic", label: "Ordo Diagnostic", note: "The customer entrance" },
      { key: "software", label: "Applied software", note: "All four in one view" },
      { key: "engine", label: "Ordo Engine", note: "Ordo software family", via: "software" },
      { key: "stewardship", label: "Ordo Stewardship", note: "Ordo software family", via: "software" },
      { key: "breakpoint", label: "Breakpoint", note: "Independent offering" },
      { key: "mesh", label: "Mesh", note: "Independent offering" },
    ],
  },
  {
    key: "research",
    label: "Research & Products",
    note: "Company-originated work",
    items: [
      { key: "research", label: "Overview & Human Structure" },
      { key: "briefcase", label: "Briefcase", note: "Leadership and direction" },
      { key: "forma", label: "Forma", note: "Personally formed intelligence" },
      { key: "lumen", label: "Lumen", note: "Learning and the classroom" },
    ],
  },
];

export const CONTEXT = {
  ordo: {
    label: "General Ordo",
    items: [["ordo", "Overview"], ["infrastructure", "Infrastructure"], ["engine", "Engine"], ["stewardship", "Stewardship"]],
    relatedLabel: "Related · separate",
    related: [["breakpoint", "Breakpoint"], ["mesh", "Mesh"]],
  },
  enterprise: {
    label: "Diagnostics & Software",
    items: [["enterprise", "Overview"], ["diagnostic", "Ordo Diagnostic"], ["software", "Applied software"]],
    relatedLabel: "Capabilities",
    related: [["engine", "Engine"], ["stewardship", "Stewardship"], ["breakpoint", "Breakpoint"], ["mesh", "Mesh"]],
    via: "software",
  },
  research: {
    label: "Research & Products",
    items: [["research", "Overview"], ["briefcase", "Briefcase"], ["forma", "Forma"], ["lumen", "Lumen"]],
  },
};
